export const userInfoJsonSelector = ({userInfoJson}) => userInfoJson